import * as React from "react"

import { cn } from "@/lib/utils"
import Cookies from "js-cookie"
import { useTranslation } from "react-i18next"

// Figma：胶囊状双语切换轨道（背景=主题色 accent，被选中那个为白底圆角胶囊）
// 仅展示 EN ↔ 繁，与既有 language-box.tsx 行为一致（zh-CN 一直注释，未启用）。
const languages = [
  { label: "English", value: "en" },
  { label: "繁體",    value: "zh-HK" },
  // { label: "简体", value: "zh-CN" },
] as const

type LanguageBoxProps = {
  className?: string
  compact?: boolean
}

export default function LanguageBox({
  className,
  compact = false,
}: LanguageBoxProps) {
  const [value, setValue] = React.useState(Cookies.get('i18next') || "zh-HK")
  const { i18n } = useTranslation()

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full bg-accent p-1",
        compact ? "p-0.5" : "",
        // 1920 设计稿：胶囊容器锁定 139×39（padding 4 + gap 4 + 两个 segment 自适应）
        !compact && "min-[1920px]:h-[39px] min-[1920px]:w-[139px] min-[1920px]:gap-1 min-[1920px]:justify-center",
        className
      )}
    >
      {languages.map((language) => {
        const selected = value === language.value
        return (
          <button
            key={language.value}
            type="button"
            onClick={() => {
              i18n.changeLanguage(language.value)
              Cookies.set('i18next', language.value)
              setValue(language.value)
              window.location.reload()
            }}
            className={cn(
              "cursor-pointer rounded-full transition-colors",
              compact ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs",
              "font-medium",
              // 1920：每段高 31、横向 padding 12、字号 14（与登录页 LangToggle 对齐）
              !compact && "min-[1920px]:h-[31px] min-[1920px]:px-3 min-[1920px]:text-sm",
              selected
                ? "bg-white text-[#1F2937] shadow-sm"
                : "bg-transparent text-[#1F2937]/80 hover:text-[#1F2937]"
            )}
          >
            {language.label}
          </button>
        )
      })}
    </div>
  )
}
